module.exports = __webpack_public_path__ + "static/media/mailru.3cc0d9d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/mailru.svg
// module id = 254
// module chunks = 0